import Vue from "vue";
import Notifications from "./Notifications";

Vue.mixin(Notifications);
